export const API_BACKEND = 'https://admin.convert68.com/wp-json/convert/v1/'
export const IMAGE_EMPTY = 'https://e7.pngegg.com/pngimages/829/733/png-clipart-logo-brand-product-trademark-font-not-found-logo-brand.png'
